import { DetailedHTMLProps, InputHTMLAttributes, useState } from 'react';

interface Props {
  initialValue?: number;
  onSet: (value: number) => void;
}

const NumberInput: React.FC<Props &
  Omit<DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>, 'value' | 'type'>> = ({
  initialValue,
  onSet,
  ...props
}) => {
  const [text, setText] = useState(initialValue?.toString?.() ?? '');
  return (
    <input
      type='number'
      value={text}
      onChange={e => {
        setText(e.target.value);
        const parsed = parseInt(e.target.value);
        if (!Number.isNaN(parsed)) onSet(parsed);
      }}
      style={{ MozAppearance: 'textfield' }}
      {...props}
    />
  );
};

export default NumberInput;
